export default [
  /**
   * DM 创作
   */
  {
    path: '/creator/editor/DM',
    name: 'creatorEditorDM',
    component: () => import('@/views/creator/editor/DM/DM/DM.vue'),
    meta: { title: '创作', requireAuth: true }
  },
  {
    path: '/creator/editor/DM/editor',
    name: 'creatorEditorDMeditor',
    component: () => import('@/views/creator/editor/DM/editor.vue'),
    meta: { title: '创作', requireAuth: true }
  },

  /**
   * JM 创作
   */
  {
    path: '/creator/editor/JM',
    name: 'creatorEditorJM',
    component: () => import('@/views/creator/editor/JM/JM.vue'),
    meta: { title: '创作', requireAuth: true }
  },
  {
    path: '/creator/editor/JM/editor',
    name: 'creatorEditorHJEditor',
    component: () => import('@/views/creator/editor/JM/editor.vue'),
    meta: { title: '创作', requireAuth: true }
  },

  /**
   * HJ 创作
   */
  {
    path: '/creator/editor/HJ',
    name: 'creatorEditorHJ',
    component: () => import('@/views/creator/editor/HJ/HJ.vue'),
    meta: { title: '创作', requireAuth: true }
  },
  {
    path: '/creator/editor/DM/editor',
    name: 'creatorEditorDMeditor',
    component: () => import('@/views/creator/editor/DM/editor.vue'),
    meta: { title: '创作', requireAuth: true }
  },

  /**
   * TM 创作
   */
  {
    path: '/creator/editor/TM',
    name: 'creatorEditorTM',
    component: () => import('@/views/creator/editor/TM/index.vue'),
    meta: { title: '创作', requireAuth: true }
  },
  {
    path: '/creator/editor/SS',
    name: 'creatorEditorSS',
    component: () => import('@/views/creator/editor/SS/index.vue'),
    meta: { title: '创作', requireAuth: true }
  },
  {
    path: '/creator/editor/TT',
    name: 'creatorEditorTT',
    component: () => import('@/views/creator/editor/TT/index.vue'),
    meta: { title: '创作', requireAuth: true }
  },

  {
    path: '/creator/topic',
    name: 'creatorTopic',
    component: () => import('@/views/creator/topic/topic.vue'),
    meta: { title: '话题库', requireAuth: true }
  },
  {
    path: '/creator/copywriting',
    name: 'creatorCopywriting',
    component: () => import('@/views/creator/copywriting/copywriting.vue'),
    meta: { title: '文案库', requireAuth: true }
  }
]
